// Configuration for "Sign in with Google" on the web. The OAuth Client ID
// is the same for all hostnames (a single Google Cloud project) — but we
// still pick it at runtime so local dev can override via env var.
//
// Production Client ID is a public identifier, not a secret.

export const GOOGLE_SDK_URL =
  "https://accounts.google.com/gsi/client";

const PROD_CLIENT_ID =
  "362292411685-ol5tf3mcp6f5rqiafladijpe08krbj2k.apps.googleusercontent.com";

export const getGoogleClientId = (): string => {
  return process.env.REACT_APP_GOOGLE_DEV_CLIENT_ID || PROD_CLIENT_ID;
};
